'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
// Lives apart from SidebarHoverCard so its non-sidebar users, like agent rows, don't pull in the lazy SpaceIcon.
const LazyProjectIcon = Dynamic(async () => {
    const { SpaceIcon } = await import('#pplx/frontend/apps/ask/spaces-shared/SpaceIcon.js');
    return { default: SpaceIcon };
});
/** Project icon and truncating title for a hover card's header or subtitle. */
export const SidebarHoverCardProjectLabel = ({ title, icon }) => (_jsxs("span", { className: "flex min-w-0 items-center gap-1", children: [_jsx("span", { className: "shrink-0", children: _jsx(LazyProjectIcon, { space: icon ?? {}, size: "small" }) }), _jsx("span", { className: "truncate", children: title })] }));
//# sourceMappingURL=SidebarHoverCardProjectLabel.js.map